export default {
    select: "Seleziona Indirizzo di spedizione",
    shippingRulesTip: "Devi seguire le regole locali per la spedizione"
}